module.exports = __webpack_public_path__ + "img/013-thinking.c039d1c3.svg";